// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__MEQPA","header":"ReportDetails_header__3BmYk","title":"ReportDetails_title__1FtwD","left":"ReportDetails_left__10Z0x"};